/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteRouteImport } from './routes/signin.route'
import { Route as SettingsRouteRouteImport } from './routes/settings.route'
import { Route as ManageRouteRouteImport } from './routes/manage.route'
import { Route as ChatRouteRouteImport } from './routes/chat.route'
import { Route as IndexRouteRouteImport } from './routes/index.route'
import { Route as CpdIndexRouteRouteImport } from './routes/cpd/index.route'
import { Route as AnalyticsIndexRouteRouteImport } from './routes/analytics/index.route'
import { Route as CpdNewRouteRouteImport } from './routes/cpd/new.route'
import { Route as CallConversationIdRouteRouteImport } from './routes/call.$conversationId.route'
import { Route as AnalyticsDashboardIdRouteRouteImport } from './routes/analytics/$dashboardId.route'
import { Route as AuthGoogleCallbackRouteRouteImport } from './routes/auth.google.callback.route'

const SigninRouteRoute = SigninRouteRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageRouteRoute = ManageRouteRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRouteRoute = ChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/',
  path: '',
  getParentRoute: () => rootRouteImport,
} as any)
const CpdIndexRouteRoute = CpdIndexRouteRouteImport.update({
  id: '/cpd/',
  path: '/cpd',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRouteRoute = AnalyticsIndexRouteRouteImport.update({
  id: '/analytics/',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CpdNewRouteRoute = CpdNewRouteRouteImport.update({
  id: '/cpd/new',
  path: '/cpd/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CallConversationIdRouteRoute = CallConversationIdRouteRouteImport.update({
  id: '/call/$conversationId',
  path: '/call/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsDashboardIdRouteRoute =
  AnalyticsDashboardIdRouteRouteImport.update({
    id: '/analytics/$dashboardId',
    path: '/analytics/$dashboardId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthGoogleCallbackRouteRoute = AuthGoogleCallbackRouteRouteImport.update({
  id: '/auth/google/callback',
  path: '/auth/google/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/chat': typeof ChatRouteRoute
  '/manage': typeof ManageRouteRoute
  '/settings': typeof SettingsRouteRoute
  '/signin': typeof SigninRouteRoute
  '/analytics/$dashboardId': typeof AnalyticsDashboardIdRouteRoute
  '/call/$conversationId': typeof CallConversationIdRouteRoute
  '/cpd/new': typeof CpdNewRouteRoute
  '/analytics/': typeof AnalyticsIndexRouteRoute
  '/cpd/': typeof CpdIndexRouteRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/chat': typeof ChatRouteRoute
  '/manage': typeof ManageRouteRoute
  '/settings': typeof SettingsRouteRoute
  '/signin': typeof SigninRouteRoute
  '/analytics/$dashboardId': typeof AnalyticsDashboardIdRouteRoute
  '/call/$conversationId': typeof CallConversationIdRouteRoute
  '/cpd/new': typeof CpdNewRouteRoute
  '/analytics': typeof AnalyticsIndexRouteRoute
  '/cpd': typeof CpdIndexRouteRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRouteRoute
  '/chat': typeof ChatRouteRoute
  '/manage': typeof ManageRouteRoute
  '/settings': typeof SettingsRouteRoute
  '/signin': typeof SigninRouteRoute
  '/analytics/$dashboardId': typeof AnalyticsDashboardIdRouteRoute
  '/call/$conversationId': typeof CallConversationIdRouteRoute
  '/cpd/new': typeof CpdNewRouteRoute
  '/analytics/': typeof AnalyticsIndexRouteRoute
  '/cpd/': typeof CpdIndexRouteRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chat'
    | '/manage'
    | '/settings'
    | '/signin'
    | '/analytics/$dashboardId'
    | '/call/$conversationId'
    | '/cpd/new'
    | '/analytics/'
    | '/cpd/'
    | '/auth/google/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chat'
    | '/manage'
    | '/settings'
    | '/signin'
    | '/analytics/$dashboardId'
    | '/call/$conversationId'
    | '/cpd/new'
    | '/analytics'
    | '/cpd'
    | '/auth/google/callback'
  id:
    | '__root__'
    | '/'
    | '/chat'
    | '/manage'
    | '/settings'
    | '/signin'
    | '/analytics/$dashboardId'
    | '/call/$conversationId'
    | '/cpd/new'
    | '/analytics/'
    | '/cpd/'
    | '/auth/google/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  ChatRouteRoute: typeof ChatRouteRoute
  ManageRouteRoute: typeof ManageRouteRoute
  SettingsRouteRoute: typeof SettingsRouteRoute
  SigninRouteRoute: typeof SigninRouteRoute
  AnalyticsDashboardIdRouteRoute: typeof AnalyticsDashboardIdRouteRoute
  CallConversationIdRouteRoute: typeof CallConversationIdRouteRoute
  CpdNewRouteRoute: typeof CpdNewRouteRoute
  AnalyticsIndexRouteRoute: typeof AnalyticsIndexRouteRoute
  CpdIndexRouteRoute: typeof CpdIndexRouteRoute
  AuthGoogleCallbackRouteRoute: typeof AuthGoogleCallbackRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat': {
      id: '/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cpd/': {
      id: '/cpd/'
      path: '/cpd'
      fullPath: '/cpd/'
      preLoaderRoute: typeof CpdIndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AnalyticsIndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cpd/new': {
      id: '/cpd/new'
      path: '/cpd/new'
      fullPath: '/cpd/new'
      preLoaderRoute: typeof CpdNewRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/call/$conversationId': {
      id: '/call/$conversationId'
      path: '/call/$conversationId'
      fullPath: '/call/$conversationId'
      preLoaderRoute: typeof CallConversationIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/$dashboardId': {
      id: '/analytics/$dashboardId'
      path: '/analytics/$dashboardId'
      fullPath: '/analytics/$dashboardId'
      preLoaderRoute: typeof AnalyticsDashboardIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/auth/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  ChatRouteRoute: ChatRouteRoute,
  ManageRouteRoute: ManageRouteRoute,
  SettingsRouteRoute: SettingsRouteRoute,
  SigninRouteRoute: SigninRouteRoute,
  AnalyticsDashboardIdRouteRoute: AnalyticsDashboardIdRouteRoute,
  CallConversationIdRouteRoute: CallConversationIdRouteRoute,
  CpdNewRouteRoute: CpdNewRouteRoute,
  AnalyticsIndexRouteRoute: AnalyticsIndexRouteRoute,
  CpdIndexRouteRoute: CpdIndexRouteRoute,
  AuthGoogleCallbackRouteRoute: AuthGoogleCallbackRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
